import Typography from '@mui/material/Typography';
import React from 'react';

export const ProgressionListCommentRow = (props: { comment: string }) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ m: '5px', ml: '15px' }}
    >
      {props.comment}
    </Typography>
  );
};
